/*
 * Copied over from Sf.GetNavBarColors and modified to work with a background and text color.
 * Orginal function based all four color purely upon the background color.
 */
export function getInteractionColorsFromColor(background, text) {
    const backgroundHSL = hexToHsl(background);

    const h = backgroundHSL.h;
    const s = backgroundHSL.s;
    const l = backgroundHSL.l;

    const shouldHoverDarken = (l > 50);

    let backgroundHoverLightness = l + 10;
    let backgroundActiveLightness = l - 10;
    if (shouldHoverDarken) {
        backgroundHoverLightness = l - 10;
        backgroundActiveLightness = l + 10;
    }

    var colorInHSL = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    var hoverColorInHSL = 'hsl(' + h + ', ' + s + '%, ' + backgroundHoverLightness + '%)';
    var activeColorInHSL = 'hsl(' + h + ', ' + s + '%, ' + backgroundActiveLightness + '%)';

    const textHSL = hexToHsl(text);

    let textHoverLightness = textHSL.l + 10;
    let textActiveLightness = textHSL.l - 10;
    if (shouldHoverDarken) {
        textHoverLightness = textHSL.l - 10;
        textActiveLightness = textHSL.l + 10;
    }

    var textColorInHSL = 'hsl(' + textHSL.h + ', ' + textHSL.s + '%, ' + textHSL.l + '%)';
    var hoverTextColorInHSL = 'hsl(' + textHSL.h + ', ' + textHSL.s + '%, ' + textHoverLightness + '%)';
    var activeTextColorInHSL = 'hsl(' + textHSL.h + ', ' + textHSL.s + '%, ' + textActiveLightness + '%)';

    return {
        MainColor: colorInHSL,
        HoverColor: hoverColorInHSL,
        ActiveColor: activeColorInHSL,
        TextColor: textColorInHSL,
        HoverTextColor: hoverTextColorInHSL,
        ActiveTextColor: activeTextColorInHSL
    };

    function hexToHsl(hex) {
        let hexToParse;
        if (hex.length === 4) {
            hexToParse = `#${hex.substring(1)}${hex.substring(1)}`;
        } else {
            hexToParse = hex;
        }
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexToParse);

        //Getthe hsl values (convert to rgb first)
        var r = parseInt(result[1], 16);
        var g = parseInt(result[2], 16);
        var b = parseInt(result[3], 16);

        r /= 255, g /= 255, b /= 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if (max == min) {
            h = s = 0; // achromatic
        } else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }

        s = s * 100;
        s = Math.round(s);
        l = l * 100;
        l = Math.round(l);
        h = Math.round(360 * h);

        return {
            s: s,
            l: l,
            h: h
        }
    }

    function hslToHex(hsl) {
        hsl = hsl.match(/^hsla?\(\s?(\d+)(?:deg)?,?\s(\d+)%,?\s(\d+)%,?\s?(?:\/\s?\d+%|\s+[\d+]?\.?\d+)?\)$/i);
        if (!hsl) {
            return null;
        }
        let h = hsl[1];
        let s = hsl[2];
        let l = hsl[3];
        h /= 360;
        s /= 100;
        l /= 100;
        let r, g, b;
        if (s === 0) {
            r = g = b = l;
        } else {
            const hue2rgb = function (p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        const toHex = function (x) {
            const hex = Math.round(x * 255).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };
        return '#' + toHex(r) + toHex(g) + toHex(b);
    }
}